import { defineComponent as _defineComponent } from 'vue'
import Dialog from "@/components/vuetify-wrappers/NjDialog.vue";
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import { useBriefcaseStore } from "@/pinia/briefcase";
import { computed, nextTick, ref, watch } from "vue";
import { ApiService, SnackbarService } from "@/services";
import { BriefcaseFolder, VignetteHelpers } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddNewBriefcaseFolderDialog',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["ok", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: "ok", folder: BriefcaseFolder): void;
  (e: "close"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpen: boolean;
};


watch(props, () => {
  if (props.isOpen) {
    nextTick(() => {
      folderNameInput.value?.resetValidation();
    });
  }
});

const folderNameInput = ref<{ resetValidation: () => void } | null>(null);

const briefcaseStore = useBriefcaseStore();

const folderName = ref("");
const newFolderNameValidated = computed(() => {
  return (
    !!folderName.value.trim() &&
    folderName.value?.trim().length <= 100 &&
    briefcaseStore.isNewFolderUnique(folderName.value).value
  );
});
const addNewFolder = async () => {
  const validatedName = folderName.value.trim();
  try {
    const response = await ApiService.postBriefcaseFolderAdd(validatedName);
    VignetteHelpers.Analytics.push({
      ["event"]: "briefcase-add-folder",
    });
    SnackbarService.displaySnackbar(
      `Folder "${validatedName}" created.`,
      "primary"
    );
    folderName.value = "";
    emit("ok", response);
  } catch (e) {
    SnackbarService.displaySnackbar("An error occurred, please try again.");
  }
};



return { __sfc: true,props, folderNameInput, briefcaseStore, folderName, newFolderNameValidated, addNewFolder, emit, Dialog, NjBtn }
}

})